module.exports = __webpack_public_path__ + "img/Vetco-Logo.b9a952f8.svg";